<app-page-header>{{ 'Dashboard' }}</app-page-header>

<form [formGroup]="filters">
    <mat-grid-list [cols]="(mobileMode$ | async) ? 1 : (tabletMode$ | async) ? 2 : 4" [rowHeight]="105" gutterSize="1.5rem">
        <mat-grid-tile class="stat-card">
            <mat-card>
                <mat-card-content>
                    <app-avatar-block [isLoadingInitialData]="!(pmc$ | async)" [svgIcon]="'v2:fi-br-building'" animated delayed>
                        <span avatarTitle>{{ ((pmc$ | async)?.organizationsCount || 0) | number:'1.0':'en-US' }}</span>
                        <span avatarDescription>{{ ((pmc$ | async)?.organizationsCount || 0) | i18nPlural: organizationsMappingTerm }}</span>
                    </app-avatar-block>
                </mat-card-content>
            </mat-card>
        </mat-grid-tile>

        <mat-grid-tile class="stat-card">
            <mat-card>
                <mat-card-content>
                    <app-avatar-block [isLoadingInitialData]="!(pmc$ | async)" [svgIcon]="'v2:fi-br-house-building'" animated delayed>
                        <span avatarTitle>{{ ((pmc$ | async)?.unitsCount || 0) | number:'1.0':'en-US' }}</span>
                        <span avatarDescription>{{ ((pmc$ | async)?.organizationsCount || 0) | i18nPlural: unitsMappingTerm  }}</span>
                    </app-avatar-block>
                </mat-card-content>
            </mat-card>
        </mat-grid-tile>

        <mat-grid-tile *ngIf="!(tabletMode$ | async)" class="notifications-card"
                       [colspan]="2" [rowspan]="(largerMode$ | async) && !(tabletMode$ | async) ? 9 : 5">
            <ng-template [ngTemplateOutlet]="notificationsList"></ng-template>
        </mat-grid-tile>

        <mat-grid-tile [rowspan]="4" [colspan]="(largerMode$ | async) && !(tabletMode$ | async) ? 2 : 1">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>{{ 'Requests' }}</mat-card-title>
                    <mat-toolbar>
                        <mat-form-field class="date-filter" appearance="outline" subscriptSizing="dynamic">
                            <mat-select [panelClass]="'v2-panel'"
                                        placeholder="{{ 'Filter Requests by Date' }}"
                                        formControlName="requestsFilterByDate">
                                <mat-option [value]="filterByDatePlaceholders.CURRENT_MONTH">{{ 'This Month' }}</mat-option>
                                <mat-option [value]="filterByDatePlaceholders.LAST_MONTH">{{ 'Last Month' }}</mat-option>
                                <mat-option [value]="filterByDatePlaceholders.CURRENT_YEAR">{{ 'This Year' }}</mat-option>
                                <mat-option [value]="filterByDatePlaceholders.LAST_YEAR">{{ 'Last Year' }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-toolbar>
                </mat-card-header>

                <mat-progress-bar mode="query" color="primary"
                                  [class.active]="charts?.requests && filters.get('requestsFilterByDate').disabled">
                </mat-progress-bar>

                <mat-divider></mat-divider>

                <mat-card-content>
                    <div class="donut-chart-holder" animated>
                        <ng-container *ngIf="charts?.requests; else loadingChart">
                            <canvas *ngIf="charts.requests.total() > 0; else loadingChart"
                                    [type]="'doughnut'"
                                    [datasets]="[charts.requests.dataset]"
                                    [labels]="charts.requests.labels"
                                    [options]="charts.requests.options"
                                    baseChart>
                            </canvas>

                            <span class="number" animated [fadeFrom]="'top'">{{ charts.requests.total() | number:'1.0':'en-US' }}</span>
                            <span animated [fadeFrom]="'top'">{{ 'Total' }}</span>
                        </ng-container>
                    </div>
                </mat-card-content>

                <mat-card-footer>
                    <mat-list *ngIf="charts?.requests; else loadingChartLegend">
                        <mat-list-item *ngFor="let count of charts.requests.dataset.data; let i = index">
                            <mat-icon [style.color]="charts.requests.dataset.backgroundColor[i]" matListItemIcon>trip_origin</mat-icon>
                            <span matListItemLine>{{ charts.requests.labels[i] + ' Requests' }}</span>
                            <span matListItemLine>{{ (count | number:'1.0':'en-US') || '0' }}</span>
                        </mat-list-item>
                    </mat-list>
                </mat-card-footer>
            </mat-card>
        </mat-grid-tile>

        <mat-grid-tile [rowspan]="4" [colspan]="(largerMode$ | async) && !(tabletMode$ | async) ? 2 : 1">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>{{ 'Violations' }}</mat-card-title>
                    <mat-toolbar>
                        <mat-form-field class="date-filter" appearance="outline" subscriptSizing="dynamic">
                            <mat-select [panelClass]="'v2-panel'"
                                        placeholder="{{ 'Filter Violations by Date' }}"
                                        formControlName="violationsFilterByDate">
                                <mat-option [value]="filterByDatePlaceholders.CURRENT_MONTH">{{ 'This Month' }}</mat-option>
                                <mat-option [value]="filterByDatePlaceholders.LAST_MONTH">{{ 'Last Month' }}</mat-option>
                                <mat-option [value]="filterByDatePlaceholders.CURRENT_YEAR">{{ 'This Year' }}</mat-option>
                                <mat-option [value]="filterByDatePlaceholders.LAST_YEAR">{{ 'Last Year' }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-toolbar>
                </mat-card-header>

                <mat-progress-bar mode="query" color="primary"
                                  [class.active]="charts?.violations && filters.get('violationsFilterByDate').disabled">
                </mat-progress-bar>

                <mat-divider></mat-divider>

                <mat-card-content>
                    <div class="donut-chart-holder" animated>
                        <ng-container *ngIf="charts?.violations; else loadingChart">
                            <canvas *ngIf="charts.violations.total() > 0; else loadingChart"
                                    [type]="'doughnut'"
                                    [datasets]="[charts.violations.dataset]"
                                    [labels]="charts.violations.labels"
                                    [options]="charts.violations.options"
                                    baseChart>
                            </canvas>

                            <span class="number" animated [fadeFrom]="'top'">{{ charts.violations.total() | number:'1.0':'en-US' }}</span>
                            <span animated [fadeFrom]="'top'">{{ 'Total' }}</span>
                        </ng-container>
                    </div>
                </mat-card-content>

                <mat-card-footer>
                    <mat-list *ngIf="charts?.violations; else loadingChartLegend">
                        <mat-list-item *ngFor="let count of charts.violations.dataset.data; let i = index">
                            <mat-icon [style.color]="charts.violations.dataset.backgroundColor[i]" matListItemIcon>trip_origin</mat-icon>
                            <span matListItemLine>{{ charts.violations.labels[i] + ' Violations' }}</span>
                            <span matListItemLine>{{ (count | number:'1.0':'en-US') || '0' }}</span>
                        </mat-list-item>
                    </mat-list>
                </mat-card-footer>
            </mat-card>
        </mat-grid-tile>

        <mat-grid-tile *ngIf="tabletMode$ | async" class="notifications-card"
                       [colspan]="(mobileMode$ | async) ? 1 : 2" [rowspan]="5">
            <ng-template [ngTemplateOutlet]="notificationsList"></ng-template>
        </mat-grid-tile>

        <mat-grid-tile class="collection-card"
                       [colspan]="(mobileMode$ | async) ? 1 : (tabletMode$ | async) ? 2 : 4" [rowspan]="5">
            <mat-card>
                <mat-card-header>
                    <mat-card-title>
                        {{ 'Collection Progress' }}
                        <mat-card-subtitle>
                            <mat-chip-set [attr.aria-label]="'coming soon'">
                                <mat-chip class="coming-soon-flag"
                                          highlighted
                                          animated
                                          disableRipple>
                                    <span>{{ 'Coming Soon' }}</span>
                                </mat-chip>
                            </mat-chip-set>
                        </mat-card-subtitle>
                    </mat-card-title>
                    <mat-toolbar>
                        <ng-container *ngIf="desktopMode$ | async; else collectionFilters">
                            <button mat-flat-button linkButton disableRipple [matMenuTriggerFor]="collectionFiltersMenu">
                                <mat-icon [svgIcon]="'v2:fi-br-menu-dots'"></mat-icon>
                            </button>
                            <mat-menu #collectionFiltersMenu="matMenu" xPosition="before" class="v2-panel" [overlapTrigger]="false">
                            </mat-menu>
                        </ng-container>
                        <ng-template #collectionFilters>
                            <div class="collection-filters">
                                <mat-form-field class="communities-filter" appearance="outline" subscriptSizing="dynamic">
                                    <mat-select [panelClass]="'v2-panel'" placeholder="--" formControlName="collectionsFilterByCommunity">
                                        <mat-option [value]="-1">{{ 'All Communities' }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                    <mat-select [panelClass]="'v2-panel'" placeholder="--" formControlName="collectionsFilterByCalendar">
                                        <mat-option [value]="'calendar'">{{ 'Calendar' }}</mat-option>
                                        <mat-option [value]="'fiscal'">{{ 'Fiscal' }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                    <mat-select [panelClass]="'v2-panel'" placeholder="--" formControlName="collectionsFilterByYear">
                                        <mat-option [value]="2024">{{ '2024' }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </ng-template>
                    </mat-toolbar>
                </mat-card-header>

                <mat-progress-bar mode="query" color="primary" [class.active]="false"></mat-progress-bar>

                <mat-divider></mat-divider>

                <mat-card-content>
                    <app-empty-state subDirectory="card" icon="collection-progress">
                        <span emptyStateTitle>{{ 'No collection progress yet' }}</span>
                        <span emptyStateText>{{ 'Your collection progress will appear here once activity starts' }}</span>
                    </app-empty-state>
                </mat-card-content>
            </mat-card>
        </mat-grid-tile>
    </mat-grid-list>
</form>

<ng-template #loadingChart>
    <canvas [type]="'doughnut'"
            [datasets]="[chartPlaceholder.dataset]"
            [labels]="chartPlaceholder.labels"
            [options]="chartPlaceholder.options"
            baseChart>
    </canvas>
</ng-template>

<ng-template #loadingChartLegend>
    <mat-list class="loading-legend">
        <mat-list-item animated>
            <mat-icon matListItemIcon>trip_origin</mat-icon>
            <span matListItemLine></span>
            <span matListItemLine></span>
        </mat-list-item>

        <mat-list-item animated>
            <mat-icon matListItemIcon>trip_origin</mat-icon>
            <span matListItemLine></span>
            <span matListItemLine></span>
        </mat-list-item>
    </mat-list>
</ng-template>

<ng-template #notificationsList>
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{ 'Notifications' }}</mat-card-title>
            <mat-toolbar>
                <button mat-flat-button linkButton disableRipple
                        [matMenuTriggerFor]="notificationActionsMenu"
                        [disabled]="(saving$ | async) || (notifications$ | async)?.length === 0">
                    <mat-icon [svgIcon]="'v2:fi-br-menu-dots'"></mat-icon>
                </button>
                <mat-menu #notificationActionsMenu="matMenu" xPosition="before" class="v2-panel" [overlapTrigger]="false">
                    <button mat-menu-item (click)="openNotifications()">
                        {{ 'View All' }}
                    </button>
                    <button mat-menu-item (click)="notificationList.markAsRead([])">
                        {{ 'Mark All as Read' }}
                    </button>
                    <button mat-menu-item (click)="notificationList.deleteNotifications([])">
                        {{ 'Delete All Notifications' }}
                    </button>
                </mat-menu>
            </mat-toolbar>
        </mat-card-header>

        <mat-progress-bar mode="query" color="primary" [class.active]="saving$ | async"></mat-progress-bar>

        <mat-divider></mat-divider>

        <mat-card-content class="notifications-layout">
            <app-notifications-list #notificationList [isDashboardCard]="true" (workingStateUpdated)="saving$.next($event)">
            </app-notifications-list>
        </mat-card-content>
    </mat-card>
</ng-template>
